import type { ArticleResponse, ArticleDraftResponse } from '../../api/queries';
import { ArticlesListItem } from './ArticlesListItem/ArticlesListItem';
import classes from './ArticlesList.module.css';

type ArticlesListProps = {
  articles: Array<ArticleResponse | ArticleDraftResponse>;
  type: 'draft' | 'published';
  isContentCreator: boolean;
};

export const ArticlesList = ({
  articles,
  type,
  isContentCreator,
}: ArticlesListProps) => {
  return (
    <div className={classes.articles}>
      {articles.map((article) => (
        <ArticlesListItem
          article={article}
          key={article.id}
          type={type}
          isContentCreator={isContentCreator}
        />
      ))}
    </div>
  );
};
